import PartnerController from 'controllers/partner-controller';
import Cookies from 'js-cookie';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';
import { isNoResultsPage } from 'lib/search-helpers';
import PartnerImageResults from 'components/partner/partner-image-results';

export default class PartnerJustifiedSearchController extends PartnerController {
  static targets = [
    'apiResultsWrapper',
    'loadingAnim',
  ];

  connect() {
    this.loadingResults = false;

    this.searchTerm = this.apiResultsWrapperTarget.getAttribute('data-keyword');
    this.partnerServiceUrl = this.element.getAttribute('data-partner-service-url');

    this.partnerImages = new PartnerImageResults(
      this.apiResultsWrapperTarget,
      this.searchTerm,
      this.partnerServiceUrl,
    );

    this.sharedId = this.element.getAttribute('data-sharedid');
    this.subId1 = this.element.getAttribute('data-subid-one');
    this.subId2 = this.element.getAttribute('data-subid-two');

    const urlParams = this.partnerImages.makeUrlParams(
      this.sharedId,
      this.subId1,
      this.subId2,
      this.adType,
      this.adPlacement(),
    );

    this.partnerImageOptions = {
      page: 0,
      placement: this.placement(),
      controllerElem: this.element,
      affiliate: this.apiResultsWrapperTarget.getAttribute('data-affiliate'),
      impactRadiusUrl: this.apiResultsWrapperTarget.getAttribute('data-impact-radius-url'),
      loc: this.apiResultsWrapperTarget.getAttribute('data-loc'),
      limit: this.apiResultsWrapperTarget.getAttribute('data-limit'),
      apiparams: this.apiResultsWrapperTarget.getAttribute('data-apiparams'),
      rowHeight: parseInt(this.apiResultsWrapperTarget.getAttribute('data-row-height'), 10),
      maxRows: this.apiResultsWrapperTarget.getAttribute('data-max-rows'),
      largeThumb: true,
      padResults: false,
      urlparams: urlParams,
      padWithTerm: this.apiResultsWrapperTarget.getAttribute('data-pad-with-term'),
    };

    this.getPartnerImageResults();

    this.noResultTimer = setTimeout(() => {
      triggerCustomEvent(events.sponsored_search.without_results, { searchTerm: this.searchTerm });

      if (!this.element.querySelector('.ez-resource-thumb')) {
        this.element.parentNode.removeChild(this.element);
      }
    }, this.noResultsDelay);

    window.addEventListener('resultsLoaded', this.handleNewResults, { once: true });
    window.addEventListener('resultsLoaded', this.endLoadingResults);
  }

  disconnect() {
    window.removeEventListener('resultsLoaded', this.handleNewResults, { once: true });
    window.removeEventListener('resultsLoaded', this.endLoadingResults);
    window.removeEventListener('scroll', this.loadNextResults);
  }

  partnerClick = () => {
    super.partnerClick(events.partner.infinite_scroll_click, false);
  }

  handleNewResults = (event) => {
    if (event.detail !== 'END_OF_RESULTS') {
      window.clearTimeout(this.noResultTimer);
      window.addEventListener('scroll', this.loadNextResults);
    }
  }

  adPlacement() {
    let adPlacementSuffix = document.querySelector('body').dataset.istockAdplacementSuffix;
    if (adPlacementSuffix === undefined) {
      adPlacementSuffix = '';
    }
    return isNoResultsPage() ? `NRP${adPlacementSuffix}` : `SRP${adPlacementSuffix}`;
  }

  placement() {
    return isNoResultsPage() ? 'NoResults' : 'LastPage';
  }

  getPartnerImageResults() {
    this.loadingResults = true;

    this.addLoadingIndicator();

    this.partnerImages.getResults(this.partnerImageOptions);
  }

  endLoadingResults = (event) => {
    this.loadingResults = false;
    this.removeLoadingIndicator();

    if (event.detail === 'END_OF_RESULTS') window.removeEventListener('scroll', this.loadNextResults);
  }

  loadNextResults = () => {
    if (this.scrolledIntoView('.search-results')) {
      const displayedCount = this.element.querySelectorAll('li').length;
      const totalCount = this.apiResultsWrapperTarget.getAttribute('data-total-count');

      if (this.loadingResults === false && displayedCount < totalCount) {
        this.partnerImageOptions.page += 1;

        this.getPartnerImageResults();
      }
    }
  }

  scrolledIntoView(selector) {
    const element = document.querySelector(selector);
    const docViewTop = window.pageYOffset || document.documentElement.scrollTop;
    const docViewBottom = docViewTop + window.innerHeight;
    const elementTop = element.offsetTop;
    const elementBottom = elementTop + (element.offsetHeight - 800);
    return elementBottom <= docViewBottom;
  }

  addLoadingIndicator() {
    this.loadingAnimTarget.classList.remove('is-hidden');
  }

  removeLoadingIndicator() {
    this.loadingAnimTarget.classList.add('is-hidden');
  }

  get noResultsDelay() {
    return 15 * 1000;
  }

  get adType() {
    return Cookies.get('content_type') || 'vector';
  }
}
